import { BaseService } from './base.service';

export default class InvitationsService extends BaseService {
  public async getPendingInvitations() {
    return this.axios.get(`${this.backendUrl}/invitations`);
  }

  public async acceptInvitation(teamId: string) {
    return this.axios.post(`${this.backendUrl}/invitation/${teamId}`, {});
  }

  public async declineInvitation(teamId: string) {
    return this.axios.delete(`${this.backendUrl}/invitation/${teamId}`);
  }
}
